/**
 * Customer love it — video carousel (Broadcast-style behavior, Impulse / Flickity).
 * Deferred asset: runs after vendor + theme so Flickity exists. Also boots immediately on load.
 */
(function () {
  'use strict';

  function loadHlsJs(callback) {
    if (window.Hls) {
      callback();
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
    script.onload = function () {
      callback();
    };
    document.head.appendChild(script);
  }

  function getFlkty(carousel) {
    if (typeof Flickity === 'undefined' || !carousel) return null;
    return Flickity.data(carousel);
  }

  /** Pause & mute every other `.off_sound_global` wrapper (same as reference). */
  function offsoundAllVideos(currentWrapper) {
    document.querySelectorAll('.off_sound_global').forEach(function (wrapper) {
      if (currentWrapper && wrapper === currentWrapper) return;
      var video = wrapper.querySelector('video');
      var playBtn = wrapper.querySelector('.glb_play');
      var muteBtn = wrapper.querySelector('.glb_mute');
      var posterWrapper = wrapper.querySelector('.custom-poster-wrapper');
      if (!video) return;
      video.pause();
      video.muted = true;
      if (playBtn) playBtn.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = '1';
      if (muteBtn) muteBtn.classList.add('muted');
    });
  }

  function attachVideoProgress(video, wrapper) {
    var progressBar = wrapper.querySelector('.video-progress-bar');
    if (!progressBar) {
      progressBar = document.createElement('div');
      progressBar.className = 'video-progress-bar';
      progressBar.style.position = 'absolute';
      progressBar.style.bottom = '10px';
      progressBar.style.left = '10px';
      progressBar.style.width = 'calc(100% - 20px)';
      progressBar.style.height = '4px';
      progressBar.style.background = 'rgba(255, 255, 255, 0.3)';
      progressBar.style.borderRadius = '2px';
      progressBar.style.overflow = 'hidden';
      progressBar.style.zIndex = '3';
      var progressFill = document.createElement('div');
      progressFill.className = 'video-progress-fill';
      progressFill.style.width = '0%';
      progressFill.style.height = '100%';
      progressFill.style.background = '#fff';
      progressFill.style.transition = 'width 0.2s linear';
      progressBar.appendChild(progressFill);
      wrapper.appendChild(progressBar);
    }
    var fill = progressBar.querySelector('.video-progress-fill');
    var rafId = null;
    function updateProgress() {
      if (!video.paused && !video.ended && video.duration > 0) {
        fill.style.width = (video.currentTime / video.duration) * 100 + '%';
        rafId = requestAnimationFrame(updateProgress);
      }
    }
    video.addEventListener('play', function () {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateProgress);
    });
    video.addEventListener('pause', function () {
      cancelAnimationFrame(rafId);
    });
    video.addEventListener('ended', function () {
      cancelAnimationFrame(rafId);
      fill.style.width = '0%';
    });
    video.addEventListener('loadedmetadata', function () {
      fill.style.width = '0%';
    });
  }

  /** Match reference: mute others, then play selected (Flickity.data for next). */
  function safePlayUsingFlickity(section, videoWrapper) {
    offsoundAllVideos(videoWrapper);
    if (typeof videoWrapper.__cliLoad === 'function') {
      videoWrapper.__cliLoad();
    }

    var playBtn = videoWrapper.querySelector('.glb_play');
    var video = videoWrapper.querySelector('video');
    var videoPoster = videoWrapper.querySelector('.custom-poster-wrapper');
    if (!video) return;

    var carousel = section.querySelector('.customer-love-it__slider');
    var flkty = getFlkty(carousel);

    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(function () {
          if (playBtn) playBtn.classList.add('playing');
          video.onended = function () {
            video.pause();
            if (playBtn) playBtn.classList.remove('playing');
            if (videoPoster) videoPoster.style.opacity = '1';
            var fk = getFlkty(carousel);
            if (fk && typeof fk.next === 'function') fk.next();
          };
        })
        .catch(function () {
          if (playBtn) playBtn.classList.remove('playing');
          if (videoPoster) videoPoster.style.opacity = '1';
        });
    }
  }

  function initCustomerLoveItVideos(sectionId) {
    var section = document.querySelector('#CustomerLoveIt--' + sectionId);
    if (!section) return;
    var slider = section.querySelector('.customer-love-it__slider');
    var videoWrappers = section.querySelectorAll('.customer_love_it_video');

    function isMobileView() {
      return window.innerWidth <= 767;
    }

    var thresholdValue = 0.2;
    setTimeout(function () {
      thresholdValue = 0.6;
    }, 7000);

    videoWrappers.forEach(function (wrapper) {
      var video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      function getSrc() {
        return isMobileView() ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      }
      function getPoster() {
        return isMobileView() ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      }
      function showMute() {
        return (isMobileView() ? video.dataset.muteM : video.dataset.mute) === 'true';
      }
      function shouldAutoplay() {
        var cell = wrapper.closest('.carousel-cell');
        return cell && cell.classList.contains('is-selected');
      }

      var playBtn = wrapper.querySelector('.glb_play');
      var muteBtn = wrapper.querySelector('.glb_mute');
      var hls = null;
      var isNativeHLS = false;
      var isVideoLoaded = false;

      var posterUrl = getPoster();
      var posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      posterWrapper.style.position = 'absolute';
      posterWrapper.style.top = '0';
      posterWrapper.style.left = '0';
      posterWrapper.style.width = '100%';
      posterWrapper.style.height = '100%';
      posterWrapper.style.zIndex = '1';
      posterWrapper.style.background = "url('" + posterUrl + "') center center / cover no-repeat";
      posterWrapper.style.pointerEvents = 'none';
      posterWrapper.style.transition = 'opacity 0.4s ease';
      posterWrapper.style.opacity = '1';

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      var mtp = true;
      video.removeAttribute('muted');
      if (shouldAutoplay()) {
        mtp = true;
        video.setAttribute('muted', '');
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      video.muted = mtp;

      function safePlay() {
        var flkty = getFlkty(slider);
        if (!flkty) return;
        var parentCell = video.closest('.carousel-cell');
        if (parentCell && !parentCell.classList.contains('is-selected')) {
          var cellIndex = -1;
          for (var c = 0; flkty.cells && c < flkty.cells.length; c++) {
            if (flkty.cells[c].element === parentCell) {
              cellIndex = c;
              break;
            }
          }
          if (cellIndex >= 0) flkty.select(cellIndex);
        }
        setTimeout(function () {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(function () {
                if (playBtn) playBtn.classList.add('playing');
                video.onended = function () {
                  video.pause();
                  if (playBtn) playBtn.classList.remove('playing');
                  if (posterWrapper) posterWrapper.style.opacity = '1';
                  var fk = getFlkty(slider);
                  if (fk && typeof fk.next === 'function') fk.next();
                };
              })
              .catch(function () {
                if (playBtn) playBtn.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = '1';
              });
          }
        }, 0);
      }

      video.addEventListener('playing', function () {
        if (posterWrapper) posterWrapper.style.opacity = '0';
        var flkty = getFlkty(slider);
        var slide = video.closest('.carousel-cell');
        if (!slide || !flkty || !flkty.selectedElement) return;
        if (flkty.selectedElement !== slide && typeof flkty.selectCell === 'function') {
          flkty.selectCell(slide);
        }
      });

      function pauseVideo(otherVideo, vWrapper) {
        if (otherVideo) {
          otherVideo.pause();
          var otherPlayBtn = vWrapper.querySelector('.glb_play');
          if (otherPlayBtn) otherPlayBtn.classList.remove('playing');
          var otherPoster = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPoster) otherPoster.style.opacity = '1';
        } else {
          video.pause();
          if (playBtn) playBtn.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = '1';
        }
      }

      function loadVideo() {
        var src = getSrc();
        var autoplay = shouldAutoplay();
        if (autoplay && video) {
          video.muted = true;
          if (muteBtn) muteBtn.classList.add('muted');
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }
        if (!src) return;
        video.setAttribute('data-loaded-src', src);
        isNativeHLS =
          src.indexOf('.m3u8') !== -1 && video.canPlayType('application/vnd.apple.mpegurl') !== '';

        function afterMeta() {
          attachVideoProgress(video, wrapper);
          if (autoplay) safePlay();
        }

        if (src.indexOf('.m3u8') !== -1) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', afterMeta, { once: true });
          } else {
            loadHlsJs(function () {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({
                  maxBufferLength: 3,
                  startLevel: -1,
                  capLevelToPlayerSize: true,
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                  isVideoLoaded = true;
                  attachVideoProgress(video, wrapper);
                  if (autoplay) safePlay();
                });
              }
            });
          }
        } else {
          var source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', afterMeta, { once: true });
        }
        if (playBtn) playBtn.classList.toggle('playing', autoplay);
      }

      function isVisible(entry) {
        var rect = entry.boundingClientRect;
        var intersection = entry.intersectionRect;
        var visibleRatio = rect.width ? intersection.width / rect.width : 0;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        var rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var wrap = entry.target.closest('.customer_love_it_video');
            if (!wrap) return;
            var shouldPlay = isVisible(entry) && !isOutOfView(wrap);
            if (shouldPlay) loadVideo();
            else pauseVideo();
          });
        },
        {
          threshold: (function () {
            var t = [];
            for (var i = 0; i <= 20; i++) t.push(i / 20);
            return t;
          })(),
        }
      );
      observer.observe(video);

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (video.paused) {
            offsoundAllVideos(wrapper);
            safePlay();
            video.muted = false;
            if (muteBtn) muteBtn.classList.remove('muted');
          } else {
            if (muteBtn) muteBtn.classList.add('muted');
            pauseVideo();
          }
        });
      }

      wrapper.__cliLoad = function () {
        loadVideo();
      };

      if (muteBtn) {
        muteBtn.style.display = showMute() ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }
    });
  }

  function getGroupCells(slider) {
    var desktop = parseFloat(slider.dataset.slidesDesktop) || 3;
    var tablet = parseFloat(slider.dataset.slidesTablet) || 2;
    var mobile = parseFloat(slider.dataset.slidesMobile) || 1;
    if (window.innerWidth > 1024) return desktop;
    if (window.innerWidth >= 768) return tablet;
    return mobile;
  }

  // function alignment() {
  //   return 'center';
  // }
  function alignment() {
  return window.innerWidth <= 767 ? 'left' : 'center';
}

  function initCustomerLoveItSlider(section) {
    if (typeof Flickity === 'undefined') return;
    var slider = section.querySelector('.customer-love-it__slider');
    if (!slider || slider.dataset.cliSliderInit === 'true') return;
    slider.dataset.cliSliderInit = 'true';

    var nav = slider.dataset.showNav === 'true';
    var totalSlides = slider.querySelectorAll('.carousel-cell').length;

    function getOptions() {
      var slidesToShow = getGroupCells(slider);
      var containV = totalSlides <= slidesToShow;
      var wrapV = totalSlides > slidesToShow;
      var trueNav = Boolean(nav && wrapV);
      return {
        cellAlign: alignment(),
        contain: containV,
        imagesLoaded: true,
        wrapAround: wrapV,
        autoPlay: false,
        prevNextButtons: trueNav,
        pageDots: false,
        draggable: wrapV,
        touchVerticalScroll: false,
        adaptiveHeight: false,
        percentPosition: true,
      };
    }

    var flkty = new Flickity(slider, getOptions());
    var lastSlidesToShow = getGroupCells(slider);

    function onResize() {
      var newSlides = getGroupCells(slider);
      if (newSlides !== lastSlidesToShow) {
        flkty.destroy();
        flkty = new Flickity(slider, getOptions());
        lastSlidesToShow = newSlides;
        bindSettle(flkty);
      } else {
        flkty.resize();
      }
    }

    function bindSettle(instance) {
      if (!instance || instance._cliSettleBound) return;
      instance._cliSettleBound = true;
      instance.on('settle', function () {
        var cell = instance.selectedElement;
        var videoWrapper = cell && cell.querySelector('.customer_love_it_video');
        if (videoWrapper) safePlayUsingFlickity(section, videoWrapper);
      });
    }

    bindSettle(flkty);

    var debounced =
      typeof theme !== 'undefined' &&
      theme.utils &&
      typeof theme.utils.debounce === 'function'
        ? theme.utils.debounce(300, onResize)
        : (function () {
            var t;
            return function () {
              clearTimeout(t);
              t = setTimeout(onResize, 300);
            };
          })();
    window.addEventListener('resize', debounced);
  }

  function setupOne(section) {
    if (!section || section.dataset.customerLoveItInit === 'true') return;
    if (typeof Flickity === 'undefined') return;
    var id = section.getAttribute('data-section-id');
    if (!id) return;
    section.dataset.customerLoveItInit = 'true';
    initCustomerLoveItVideos(id);
    initCustomerLoveItSlider(section);
  }

  function boot() {
    document.querySelectorAll('[data-section-type="customer-love-it"]').forEach(setupOne);
  }

  function onSectionLoad(e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-section-type="customer-love-it"]').forEach(setupOne);
  }

  if (!window.__customerLoveItListeners) {
    window.__customerLoveItListeners = true;
    document.addEventListener('page:loaded', boot);
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  if (typeof Flickity !== 'undefined') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
